/*!
 * Alpha Posts - Version: 2.4.1
 * Indeed - Copyright (c) 2026
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

const listOptions = {
  valueNames: ['name'],
  pagination: [{
    innerWindow: 1,
    outerWindow: 1,
    item: '<li><button class="page"></button></li>',
  }],
};

const THIRD_PARTY_EVENTS = ['mousedown', 'mouseup', 'pointerdown', 'pointerup', 'pointerover', 'mouseover', 'pointerenter', 'mouseenter'];

let userList, paginationWrapper, nextButton, prevButton, alphaPostsSearch, listLoadingOverlay, listLoadingText;
function blockThirdPartyEvents(el) {
  THIRD_PARTY_EVENTS.forEach((evt) => {
    el.addEventListener(evt, (e) => e.stopPropagation(), true);
  });
}

function blockAllEvents(el) {
  THIRD_PARTY_EVENTS.concat(['click']).forEach((evt) => {
    el.addEventListener(evt, (e) => e.stopPropagation(), true);
  });
}

function showListSpinner() {
  if (!listLoadingOverlay) {
    return;
  }
  const list = document.querySelector('.alphaposts-list');
  if (list) {
    listLoadingOverlay.style.height = list.offsetHeight + 'px';
  }
  listLoadingOverlay.classList.add('is-visible');
  if (listLoadingText) {
    listLoadingText.textContent = 'Loading';
  }
}

function hideListSpinner() {
  if (!listLoadingOverlay) {
    return;
  }
  listLoadingOverlay.classList.remove('is-visible');
  listLoadingOverlay.style.height = '';
  if (listLoadingText) {
    listLoadingText.textContent = '';
  }
}
function runWithListSpinner(fn) {
  setTimeout(() => {
    showListSpinner();
    setTimeout(() => {
      try {
        fn();
      } finally {
        hideListSpinner();
      }
    }, 0);
  }, 0);
}
function nextPreviousInit() {
  prevButton.disabled = true;
  paginationWrapper.dataset.page = "1";
  paginationWrapper.dataset.pages = Math.ceil(userList.items.length / listOptions.page).toString();
  userList.on('filterComplete', () => updatePagination());
  userList.on('searchComplete', () => updatePagination());
  setupPaginationNumberClick();
  showNextPage();
  showPreviousPage();
}
function updatePagination() {
  if (!paginationWrapper || !prevButton || !nextButton) {
    return;
  }
  prevButton.disabled = true;
  paginationWrapper.dataset.page = "1";
  paginationWrapper.dataset.pages = Math.ceil(userList.matchingItems.length / listOptions.page).toString();
  if (paginationWrapper.dataset.pages === '1') {
    const singlePaginationButton = document.querySelector('.alphaposts-pagination-wrapper li');
    if (singlePaginationButton) {
      singlePaginationButton.classList.add('single-page');
    }
    nextButton.disabled = true;
  } else {
    nextButton.disabled = false;
  }
}
function setupPaginationNumberClick() {
  paginationWrapper.addEventListener('click', function(e) {
    const pageEl = e.target.closest('a.page') || e.target.closest('button.page');
    if (!pageEl) {
      return;
    }
    e.stopImmediatePropagation();
    e.stopPropagation();
    const pageNumber = pageEl.innerText.trim();
    if (pageNumber === '...') {
      return;
    }
    const page = parseInt(pageNumber, 10);
    const pageSize = userList.page;
    const start = (page - 1) * pageSize + 1;
    setTimeout(() => {
      showListSpinner();
      setTimeout(() => {
        try {
          userList.show(start, pageSize);
          prevButton.disabled = (page === 1);
          nextButton.disabled = (page === parseInt(paginationWrapper.dataset.pages, 10));
          paginationWrapper.dataset.page = pageNumber;
        } finally {
          hideListSpinner();
        }
      }, 0);
    }, 0);
  }, true);
}
function showNextPage() {
    nextButton.addEventListener('click', function() {
      if (parseInt(paginationWrapper.dataset.page, 10) >= parseInt(paginationWrapper.dataset.pages, 10)) {
        return;
      }
      runWithListSpinner(() => {
        prevButton.disabled = false;
        if (parseInt(paginationWrapper.dataset.pages, 10) - parseInt(paginationWrapper.dataset.page, 10) === 1) {
          nextButton.disabled = true;
        }
        const start = parseInt(paginationWrapper.dataset.page, 10) * listOptions.page + 1;
        userList.show(start, listOptions.page);
        paginationWrapper.dataset.page = (parseInt(paginationWrapper.dataset.page, 10) + 1).toString();
      });
    });
}
function showPreviousPage() {
  prevButton.addEventListener('click', function() {
    if (parseInt(paginationWrapper.dataset.page, 10) <= 1) {
      return;
    }
    runWithListSpinner(() => {
      nextButton.disabled = false;
      if (parseInt(paginationWrapper.dataset.page, 10) === 2) {
        prevButton.disabled = true;
      }
      const start = ((parseInt(paginationWrapper.dataset.page, 10) - 1) * listOptions.page + 1) - listOptions.page;
      userList.show(start, listOptions.page);
      paginationWrapper.dataset.page = (parseInt(paginationWrapper.dataset.page, 10) - 1).toString();
    });
  });
}

function setupAlphaFilterButtons() {
  const buttons = document.querySelectorAll('.alphaposts-filter-button');
  if (!buttons.length) {
    return;
  }
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const existingFirstLetters = new Set(
    userList.items.map((item) => item.values().name.charAt(0).toUpperCase())
  );
  const missingLetters = alphabet.filter((letter) => !existingFirstLetters.has(letter));

  buttons.forEach((button) => {
    const alphaFilter = button.dataset.filter && button.dataset.filter.split(',');

    if (alphaFilter && alphaFilter.length === 1 && missingLetters.includes(alphaFilter[0])) {
      button.disabled = true;
    }

    blockAllEvents(button);

    button.addEventListener('click', function(e) {
      const activeButton = document.querySelector('.alphaposts-filter-button.active');
      if (activeButton) {
        activeButton.classList.remove('active');
      }
      e.currentTarget.classList.add('active');

      runWithListSpinner(() => {
        if (alphaPostsSearch && userList.searched) {
          alphaPostsSearch.value = '';
          userList.fuzzySearch();
        }

        if (alphaFilter) {
          userList.filter((item) => alphaFilter.includes(item.values().name.charAt(0).toUpperCase()));
        } else {
          userList.filter();
        }
      });
    });
  });
}

function alphapostsReady() {
    initializeAlphapostsPageSize();
    userList = new List('alphaposts-list-wrapper', listOptions);
    alphaPostsSearch = document.querySelector('.alphaposts-search');
    listLoadingOverlay = document.querySelector('.alphaposts-list-loading');
    listLoadingText = listLoadingOverlay ? listLoadingOverlay.querySelector('.alphaposts-list-loading-text') : null;

    const alphaPostsNoResults = document.querySelector('.alphaposts-no-results');
    const alphaPostsListWrapper = document.querySelector('.alphaposts-list');

    setupAlphaFilterButtons();

    function doSearch(e) {
        if (userList.filtered) {
            userList.filter();
        }
        userList.fuzzySearch(e.target.value.trim(), ['name']);
    }

    if (alphaPostsSearch) {
        blockThirdPartyEvents(alphaPostsSearch);
        alphaPostsSearch.addEventListener('input', (e) => {
            runWithListSpinner(() => doSearch(e));
        });
    }

    function showHideNoResults(e) {
        const showNoResults = e.visibleItems.length === 0;
        if (alphaPostsNoResults) {
            alphaPostsNoResults.style.display = showNoResults ? 'block' : 'none';
        }
        if (alphaPostsListWrapper) {
            alphaPostsListWrapper.style.display = showNoResults ? 'none' : 'block';
        }
    }

    if (alphaPostsNoResults) {
        userList.on('searchComplete', showHideNoResults);
        userList.on('filterComplete', showHideNoResults);
    }
    setTimeout(()=>{
        paginationWrapper = document.querySelector('.alphaposts-pagination-wrapper');
        nextButton = document.querySelector('.alphaposts-pagination-arrow.next');
        prevButton = document.querySelector('.alphaposts-pagination-arrow.previous');
        if (paginationWrapper) {
            blockThirdPartyEvents(paginationWrapper);
        }
        if (nextButton) {
            blockAllEvents(nextButton);
        }
        if (prevButton) {
            blockAllEvents(prevButton);
        }
        nextPreviousInit();
    }, 0);
}

function initializeAlphapostsPageSize() {
    if (window.innerWidth < 579) {
        listOptions.page = 12;
    } else if (window.innerWidth < 768) {
        listOptions.page = 20;
    } else if (window.innerWidth < 992) {
        listOptions.page = 18;
    } else {
        listOptions.page = 40;
    }
}

function updateAlphapostsPageSize() {
    if (!userList) {
        return;
    }
    if (window.innerWidth < 579) {
        if (userList.page !== 12) {
            userList.page = 12;
            userList.update();
        }
    } else if (window.innerWidth < 768) {
        if (userList.page !== 20) {
            userList.page = 20;
            userList.update();
        }
    } else if (window.innerWidth < 992) {
        if (userList.page !== 18) {
            userList.page = 18;
            userList.update();
        }
    } else {
        if (userList.page !== 40) {
            userList.page = 40;
            userList.update();
        }
    }
}

document.addEventListener("DOMContentLoaded", alphapostsReady);
window.addEventListener("resize", updateAlphapostsPageSize);

